import { Sparkles } from 'lucide-react';
import { toast } from 'sonner';
import { KbdHint } from '@/components/ui';
import { useUIStore } from '@/stores/uiStore';
import { useDayBuilder } from '@/features/ai/useDayBuilder';
import { BraindayError } from '@/services/BraindayAPI';

export function dayBuilderErrorToast(err: BraindayError) {
  switch (err.code) {
    case 'offline':
      toast.error("You're offline. Try again when you're back.");
      break;
    case 'timeout':
    case 'server':
    case 'unknown':
      toast.error('Taking longer than usual. Try again?');
      break;
    case 'rate-limit':
      toast.error("You've used today's free schedules. Upgrade to Pro for unlimited.");
      break;
    case 'app-check':
      toast.error('Verification issue. Restart the app.');
      break;
  }
}

export function CommandBar() {
  const setOpen = useUIStore((s) => s.setCommandPaletteOpen);
  const { run, loading } = useDayBuilder();

  const onBuild = async () => {
    try {
      await run();
    } catch (e) {
      if (e instanceof BraindayError) dayBuilderErrorToast(e);
    }
  };

  return (
    <div className="border-t border-line bg-canvas px-5 py-2.5">
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => setOpen(true)}
          aria-label="Ask Brainday — open command palette"
          className="flex flex-1 items-center gap-2 rounded-lg border border-line-2 bg-bg px-3 py-2 text-left text-body text-t2 can-hover:hover:bg-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-canvas"
        >
          <Sparkles className="h-3.5 w-3.5" aria-hidden />
          <span className="flex-1 truncate">
            Ask Brainday — &quot;reschedule afternoon&quot;, &quot;I&apos;m low energy&quot;…
          </span>
          <KbdHint>⌘K</KbdHint>
        </button>
        <button
          type="button"
          onClick={() => void onBuild()}
          disabled={loading}
          className="rounded-lg bg-t1 px-3 py-2 text-body font-medium text-canvas pointer-coarse:min-h-[44px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-canvas disabled:opacity-50"
        >
          {loading ? 'Building…' : 'Build my day'}
        </button>
      </div>
    </div>
  );
}
